
export const cartas = {
  hero: {
    title: 'Awarded Letters',
    subtitle: 'Technical curation of awarded consortium letters with documentary validation, operational risk analysis and comprehensive transfer monitoring. No promises. With method.',
    cta_primary: 'Schedule Strategic Assessment',
    cta_secondary: 'Talk to Specialist'
  },
  curation: {
    label: 'Technical Curation',
    title: 'Validation and Risk Analysis',
    items: [
      {
        title: 'Complete Documentary Validation',
        description: 'Thorough analysis of documentation, payment history, registration status with the administrator and verification of pending issues or operational restrictions.'
      },
      {
        title: 'Operational Risk Analysis',
        description: 'Technical evaluation of the group, current regulations, applicable fees, reserve funds and specific transfer conditions according to administrator regulations.'
      },
      {
        title: 'Scenario Modeling',
        description: 'Projection of total acquisition costs, comparison with traditional credit alternatives and feasibility analysis considering client\'s wealth profile.'
      },
      {
        title: 'Transfer Monitoring',
        description: 'Comprehensive management of the transfer process with the administrator, validation of required documentation and monitoring until operation completion.'
      }
    ]
  },
  validation: {
    label: 'Process',
    title: 'Validation and Structuring Stages',
    steps: [
      {
        title: 'Wealth Assessment',
        description: 'Analysis of wealth profile, acquisition objective, payment capacity and timeline for using the awarded credit.'
      },
      {
        title: 'Selection and Curation',
        description: 'Identification of letters compatible with profile, complete documentary validation and technical analysis of operational conditions.'
      },
      {
        title: 'Comparative Analysis',
        description: 'Scenario modeling comparing total costs of awarded letter versus traditional credit alternatives available in the market.'
      },
      {
        title: 'Operation Structuring',
        description: 'Definition of acquisition structure, analysis of tax impacts and payment flow planning according to wealth capacity.'
      },
      {
        title: 'Execution and Transfer',
        description: 'Comprehensive monitoring of transfer process with administrator until completion and credit release for use.'
      }
    ]
  },
  governance: {
    label: 'Governance',
    title: 'Transparency and Technical Limits',
    points: [
      'Acquiring an awarded letter does not guarantee future awards in other groups.',
      'Transfer costs, administrative fees and funds vary according to administrator regulations.',
      'Technical analysis considers operational risks but does not eliminate variables beyond FGT Capital\'s control.',
      'All operations are subject to registration and documentary approval by the consortium administrator.'
    ]
  },
  cta: {
    title: 'Structure Your Acquisition with Governance',
    subtitle: 'Schedule a strategic assessment for technical analysis of awarded letters compatible with your wealth profile.',
    button_primary: 'Request Assessment',
    button_secondary: 'WhatsApp'
  }
};
